import { Range, Record, List, Map } from "immutable";

export const CLEAR_FORM = "CLEAR_FORM";
export const DISABLE_FORM = "DISABLE_FORM";
export const ENABLE_FORM = "ENABLE_FORM";
export const SET_FORM_ERROR = "SET_FORM_ERROR";
export const SET_FORM_ERRORS = "SET_FORM_ERRORS";
export const CLEAR_FORM_ERROR = "CLEAR_FORM_ERROR";
export const SET_FORM_FIELD = "SET_FORM_FIELD";
export const SET_IS_FORM_ERROR_VISIBLE = "SET_IS_FORM_ERROR_VISIBLE";

export const VALIDATE_FORM_FIELD = "VALIDATE_FORM_FIELD";
export const VALIDATE_FORM_FIELD_SUCCESS = "VALIDATE_FORM_FIELD_SUCCESS";
export const VALIDATE_FORM_FIELD_ERROR = "VALIDATE_FORM_FIELD_ERROR";

export const clearForm = (state, form, Forms) =>
  state.setIn(["forms", form], new Forms().get(form));
export const disableForm = (state, form) =>
  state.setIn(["forms", form, "disabled"], true);
export const enableForm = (state, form) =>
  state.setIn(["forms", form, "disabled"], false);
export const setSentForm = (state, form) =>
  state.setIn(["forms", form, "sent"], true);
export const setFormErrors = (state, form, errors) =>
  state.setIn(["forms", form, "errors"], new Map(errors));
export const setFormError = (state, form, name, errors) => {
  state = state.setIn(["forms", form, "errors", name], errors[name]);
  return setIsFormErrorVisible(state, form, name, true);
};
export const clearFormError = (state, form, name) => {
  state = setIsFormErrorVisible(state, form, name, false);
  if (
    state.forms.get(form).errors.get(name) === undefined ||
      state.forms.get(form).errors.get(name).length === 0
  )
    return state;
  return state.setIn(["forms", form, "errors", name], []);
};
export const setIsFormErrorVisible = (state, form, key, value) => {
  if (
    (state.forms.get(form).errors.get(key) === undefined ||
      state.forms.get(form).errors.get(key).length === 0) &&
      value == true
  )
    return state;
  return state.setIn(["forms", form, "isErrorVisible", key], value);
};

// Standard forms actions
export default function formsReducer(state, feature, action, Forms) {
  feature = feature.toUpperCase();

  const payload = action.payload;

  switch (action.type) {
    case CLEAR_FORM + "_" + feature:
      return clearForm(state, payload.form, Forms);

    case DISABLE_FORM + "_" + feature:
      return disableForm(state, payload.form);

    case ENABLE_FORM + "_" + feature:
      return enableForm(state, payload.form);

    case SET_FORM_FIELD + "_" + feature:
      return state.setIn(
        ["forms", payload.form, "fields"].concat(payload.name),
        payload.value
      );

    case SET_FORM_ERRORS + "_" + feature:
      return setFormErrors(payload.form, payload.errors.errors);

    case CLEAR_FORM_ERROR + "_" + feature:
      return clearFormError(state, payload.form, payload.name);

    case SET_FORM_ERROR + "_" + feature:
      return setFormError(
        state,
        payload.form,
        payload.name,
        payload.errors.errors
      );

    case SET_IS_FORM_ERROR_VISIBLE + "_" + feature:
      return setIsFormErrorVisible(
        state,
        payload.form,
        payload.key,
        payload.value
      );
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/common/lib/formsReducer.js